import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class AdminIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><path fillRule="evenodd" d="M7 0c3.862 0 7 3.138 7 7s-3.138 7-7 7-7-3.138-7-7 3.138-7 7-7zm1.918 9.67l-.362-2.152 1.555-1.53-2.152-.31L7 3.732l-.96 1.944-2.151.311 1.555 1.53-.362 2.152L7 8.659 8.918 9.67z"/></svg>
        )
    }
}

export default withCssClassName(AdminIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/admin-icon.js